import React from 'react';
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors
} from '@dnd-kit/core';
import {
    SortableContext,
    verticalListSortingStrategy,
    arrayMove
} from '@dnd-kit/sortable';
import SortableItem from './SortableFixedChoiceItem';

const FixedChoiceDnDList = ({ items, onDragEnd }) => {
    const sensors = useSensors(useSensor(PointerSensor));

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={({ active, over }) => {
                if (active.id !== over?.id) {
                    const oldIndex = items.findIndex(item => item.id === active.id);
                    const newIndex = items.findIndex(item => item.id === over?.id);
                    const newList = arrayMove(items, oldIndex, newIndex);
                    onDragEnd(newList);
                }
            }}
        >
            <SortableContext items={items.map(item => item.id)} strategy={verticalListSortingStrategy}>
                {items.map((item) => (
                    <SortableItem key={item.id} id={item.id} item={item} />
                ))}
            </SortableContext>
        </DndContext>
    );
};

export default FixedChoiceDnDList;
